module.exports = __webpack_public_path__ + "img/lightening-icon.d4856083.svg";